import React, { useState } from 'react'
import { Form, Button, InputGroup } from "react-bootstrap"
import changePasswordIcon from "../img/change_password.svg";
import ConfirmatoryModal from "../Components/ConfirmatoryModal";
import * as formik from 'formik';
import * as yup from 'yup';
import { sendChangePassword, handleSubmit, handleChange, getModalData } from "../Functions/myfunctions";


function ChangePassword() {
    const { Formik } = formik;
    const [errorMessage, setErrorMessage] = useState("");

    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '', values: '' });
    const [urlLink, setUrlLink] = useState();
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        password: "",
        oldpassword: "",
        password2: "",
    })

    const ChangePasswordSchema = yup.object().shape({
        oldPassword: yup.string()
            .matches(/[0-9]/, "A jelszónak tartalmaznia kell számot.")
            .matches(/[a-z]/, "A jelszónak tartalmaznia kell kis betűt")
            .matches(/[A-Z]/, "A jelszónak tartalmaznia kell nagy betűt")
            .min(12, 'A jelszónak minimum 12 hosszúnak kell lennie!')
            .required('A jelszó megadása kötelező'),
        password: yup.string()
            .matches(/[0-9]/, "A jelszónak tartalmaznia kell számot.")
            .matches(/[a-z]/, "A jelszónak tartalmaznia kell kis betűt")
            .matches(/[A-Z]/, "A jelszónak tartalmaznia kell nagy betűt")
            .min(12, 'A jelszónak minimum 12 hosszúnak kell lennie!')
            .required('A jelszó megadása kötelező'),
        password2: yup.string()
            .required('A megerősítő jelszó kitöltése kötelező')
            .oneOf([yup.ref('password'), null], "A jelszónak és a megerősítő jelszónak meg kell egyeznie"),
    });


    const save = (values, actions) => {
        getModalData({ name: 'Kívánja a módosítást végrehajtani?', action: 'save', values: values }, "", modalShow, setActionName, setUrlLink, setModalShow);
    }

    const confirmationfunction = (event) => {
        event.preventDefault();
        const dataCopy = { ...actionName.values };
        delete dataCopy['password2'];
        dataCopy["sessionToken"] = sessionStorage.getItem("sessionToken");
        sendChangePassword(dataCopy);
        setModalShow(false);
    }

    return (
        <div className="form-page-content">
            <div className='custom-title'><img src={changePasswordIcon} alt="change-password-icon" /><h1>Jelszó módosítás</h1></div><br />
            <Formik initialValues={{
                oldPassword: "",
                password: "",
                password2: "",
            }}
                validationSchema={ChangePasswordSchema}
                onSubmit={(values, actions) => {
                    save(values, actions);
                }}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="Password">
                            <Form.Label >
                                Jelenlegi Jelszó*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Jelenlegi Jelszó" name="oldPassword" required value={values.oldPassword} onChange={handleChange} isInvalid={!!errors.oldPassword} autoComplete='oldPassword' />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.oldPassword}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="New-Password">
                            <Form.Label >
                                Jelszó*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Új Jelszó" name="password" required value={values.password} onChange={handleChange} isInvalid={!!errors.password} autoComplete='password' />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.password}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="New-Password2">
                            <Form.Label >
                                Jelszó újra*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Jelszó újra" name="password2" required value={values.password2} onChange={handleChange} isInvalid={!!errors.password2} autoComplete='password2' />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.password2}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Button type="submit" className="form-custom-button">Mentés</Button>
                        </Form.Group>
                        {errorMessage !== "" ? <p className="error mb-3">{errorMessage}</p> : ""}
                    </Form>
                )}
            </Formik>
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    )
}

export default ChangePassword;
